import Carousel from "./carousel";

const slidesData = [
  {
    id: "slide1",
    imageUrl:
      "https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/banner2.jpeg",
    caption: "",
  },
  {
    id: "slide2",
    imageUrl:
      "https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/DSC02194.JPG",
    caption: "",
  },
  {
    id: "slide3",
    imageUrl:
      "https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/DSC02201.JPG",
    caption: "",
  },
  {
    id: "slide4",
    imageUrl:
      "https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/bag.jpeg",
    caption: "",
  },
  {
    id: "slide5",
    imageUrl:
      "https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/DSC02210.JPG",
    caption: "",
  },
];

const Home = () => {
  return (
    <section id="banner" class="banner">
      <div class="carousel-shading">
        <div class="banner-header">
          <h1>
            Effective <br />
            Packaging <br />
            Solutions
          </h1>
          <p>
            We provide superior packaging solutions that ensure the safe and
            efficient transit of your products.
            <br />
            &#8213;
          </p>
          <button onclick="window.location='#4'">Get In Touch</button>
        </div>
      </div>
      <Carousel slides={slidesData} />
    </section>
  );
};

export default Home;
